<template>
  <form name="notification-pages-form" class="NotificationPagesForm" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col md="8" lg="6">
          <BTextarea
            v-model="form.title"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            rows="2"
            name="name"
            autofocus
            counter
          />
        </v-col>

        <v-col v-if="linkVisible" md="4" lg="6" class="align-center justify-end d-flex">
          <router-link
            :to="linkTo"
            target="_blank"
            class="NotificationPagesForm__link"
            @click.native.stop
          >
            <IconLink
              tooltip="Открыть в новой вкладке"
              :tooltip-attrs="{ left: true }"
              class="NotificationPagesForm__link-icon"
            />
          </router-link>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col md="8" lg="6">
          <BTextField
            v-model="form.url"
            label="Ссылка (по умолчанию: идентификатор записи)"
            validate="relativeUrl"
            :disabled="isView"
            :skeleton="skeleton"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <v-checkbox
              v-model="form.is_public"
              :disabled="isView"
              label="Показывать всем?"
              dense
              hide-details
              class="ma-0 pa-0"
              name="is_public"
              @change="form.participants_list_id = null"
            />
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row dense class="mt-4">
        <v-col md="10" lg="8">
          <BEditor
            v-model="form.body"
            validate="required"
            data-vv-as="Описание"
            placeholder="Введите описание"
            :disabled="isView"
            :skeleton="skeleton"
            min-height="200px"
            name="description"
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>

      <slot name="save-menu" />
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BTextField from '@/components/forms/BTextField.vue'
import IconLink from '@/components/lk/icons/LKIconLink.vue'
import { LK_NOTIFICATION_PAGES_ROUTES as ROUTES } from '@/views/LKNotificationPages/utils'


const BEditor = () => import(
  /* webpackChunkName: "BEditor" */
  '@/components/forms/BEditor.vue'
)

const createDefaultData = () => ({
  title: '',
  body: '.',
  url: '',
  is_public: false,
})

export default {
  name: 'NotificationPagesForm',
  components: {
    IconLink,
    BLayoutExpansion,
    BTextarea,
    BTextField,
    BEditor,
  },
  extends: BLayoutForm,
  props: {
    editable: Boolean,
    skeleton: Boolean,
    loading: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
    linkVisible: Boolean,
  },
  computed: {
    linkTo() {
      return {
        name: ROUTES.VIEW,
        params: {
          url: this.form.url || this.data.url,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.NotificationPagesForm {
  &__link {
    display: block;
    margin: 0 4px;
    color: $webflow-color-black;
    cursor: pointer;
    text-decoration-line: none;

    &:hover {
      opacity: 0.75;
    }
  }

  &__link-icon {
    pointer-events: none;
  }
}
</style>
